import React, { useState, useEffect } from 'react';
import './TabActivities.scss';
import Tabs from './Tabs/Tabs';
import Button from '../../partials/Button';
import InteractionContainer from '../../partials/InteractionContainer/InteractionContainer';

const TabActivities = (props) => {

  const { data } = props;
  const [tab, settab] = useState(0);

  const changetab = (selectedtab) => {
    if(tab==selectedtab){
      return;
    }else{
      settab(selectedtab)
    }
  }
 
  return (
    <InteractionContainer withFrame={true} breadcrumbs={props.breadcrumbs}>
    <div className="TabActivities">
      <div className="back-btn-container">
          <Button variant='back' text="Back" onClick={props.goBackToPreviousSegment} />
      </div>
    <br />
      <Tabs data={data} currentTab={tab} changetab={changetab} onComplete={props.onComplete}/>
     
      </div>
      </InteractionContainer>
  );

};

export default TabActivities;